import { TableCell } from '@mui/material';
import { Menu, MenuItem, Tooltip, ToggleButton } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { RouteInformation } from '../../shared/constants/RouteInformation';
import { TrackerDataType } from '../../shared/constants/constants';
import MoreOptionsIcon from '../TrackerFilter/Icons/MoreOptionsIcon';
import EditPencilIcon from '../TrackerFilter/Icons/EditPencilIcon';
import CopyUrlIcon from '../TrackerFilter/Icons/CopyUrlIcon';
import DuplicateIcon from '../TrackerFilter/Icons/DuplicateIcon';
import sxPropType from '../../shared/propTypes/sxPropType';
import { trackerFilterTypographySx, trackerPopupPaperSx } from '../TrackerFilter/trackerFilterToolbarStyles';

export default function TrackerTableEditorCell({
  handleEditMode,
  onDuplicate,
  className,
  sx,
  showDuplicate = false,
  type,
  rowId,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCopyUrl = () => {
    let routePath = RouteInformation.serviceLog.path;
    if (type === TrackerDataType.MEDIA_INTERACTION) {
      routePath = RouteInformation.mediaInteraction.path;
    } else if (type === TrackerDataType.CONTENT_LOG) {
      routePath = RouteInformation.contentLog.path;
    } else if (type === TrackerDataType.ENGAGEMENT) {
      routePath = RouteInformation.engagementLog.path;
    }

    navigator.clipboard.writeText(`${window.location.origin}${routePath}/${rowId}`);
    handleClose();
  };

  return (
    <TableCell className={className} sx={sx}>
      <Tooltip title="More options" placement="left">
        <ToggleButton
          value="more-options"
          selected={open}
          onChange={handleClick}
          size="small"
          sx={{
            color: (theme) => theme.palette.primaryDefault.main,
            border: 'none',
            padding: '0',
            borderRadius: '50%',
            width: '22px',
            height: '22px',
            transition: 'all 0.2s ease-in-out',
            '& .MuiSvgIcon-root': {
              width: '26px',
              height: '26px',
            },
            '&.Mui-selected': {
              backgroundColor: (theme) => theme.palette.primaryDark.main,
              color: (theme) => theme.palette.primaryDark.contrastText,
              '&:hover': {
                backgroundColor: (theme) => theme.palette.primaryDark.main,
              },
            },
            '&:hover': {
              color: (theme) => theme.palette.toneNeutral.main,
            },
          }}
        >
          <MoreOptionsIcon />
        </ToggleButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: {
              ...trackerPopupPaperSx,
              minWidth: 180,
              borderRadius: '12px',
              mt: 0.5,
            },
          },
        }}
      >
        <MenuItem
          onClick={() => {
            handleEditMode(true);
            handleClose();
          }}
          sx={trackerFilterTypographySx}
        >
          <EditPencilIcon sx={{ mr: 1, color: (theme) => theme.palette.toneNeutral.main }} /> Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleCopyUrl();
            handleClose();
          }}
          sx={trackerFilterTypographySx}
        >
          <CopyUrlIcon sx={{ mr: 1, color: (theme) => theme.palette.toneNeutral.main }} /> Copy URL
        </MenuItem>
        {showDuplicate && (
          <MenuItem
            onClick={() => {
              onDuplicate();
              handleClose();
            }}
            sx={trackerFilterTypographySx}
          >
            <DuplicateIcon sx={{ mr: 1, color: (theme) => theme.palette.toneNeutral.main }} /> Duplicate
          </MenuItem>
        )}
      </Menu>
    </TableCell>
  );
}

TrackerTableEditorCell.propTypes = {
  className: PropTypes.string,
  handleEditMode: PropTypes.func,
  onDuplicate: PropTypes.func,
  rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showDuplicate: PropTypes.bool,
  sx: sxPropType,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
